import React, { useMemo } from 'react'
import { Alert, List, ListItem, ListItemText } from '@mui/material'
import ReactLinkify from 'react-linkify'
import { ReviewSection, ReviewTarget } from '../../../generated/graphql'
import { useReviewContext } from './ReviewContext'

type SendBackReasonItemProps = {
  reviewSection: ReviewSection
  reviewTarget: ReviewTarget | ReviewTarget[]
}

export const SendBackReasonItem: React.FC<SendBackReasonItemProps> = ({ reviewTarget, reviewSection }) => {
  const { campaignReviewResults } = useReviewContext()

  const sendBackReasons = useMemo(() => {
    const targets = Array.isArray(reviewTarget) ? reviewTarget : [reviewTarget]
    const selectedReviewSectionCampaign = campaignReviewResults?.find((e) => e.reviewSection === reviewSection)
    return (
      selectedReviewSectionCampaign?.campaignReviews
        .map((review) => {
          if ([targets].flat().includes(review.reviewTarget)) {
            const reason = review.sendBackReason
            return {
              reason: reason || '',
              reviewTarget: review.reviewTarget,
            }
          }
        })
        .filter((r): r is NonNullable<typeof r> => (r && r.reason.length > 0) ?? false) || []
    )
  }, [campaignReviewResults, reviewSection, reviewTarget])

  if (!sendBackReasons.length) return null

  return (
    <Alert severity="error">
      <List dense disablePadding>
        {sendBackReasons.map((sendBackReasonsData) =>
          sendBackReasonsData.reason.split('\n').map((reason, index) => (
            <ListItem key={index} disablePadding dense sx={{ overflowWrap: 'anywhere', lineBreak: 'strict' }}>
              <ReactLinkify
                componentDecorator={(decoratedHref, decoratedText, key) => (
                  <a target="blank" href={decoratedHref} key={key} rel="noreferrer">
                    {decoratedText}
                  </a>
                )}
              >
                <ListItemText sx={{ '&:first-of-type': { mt: 0 } }}>{reason}</ListItemText>
              </ReactLinkify>
            </ListItem>
          )),
        )}
      </List>
    </Alert>
  )
}
